// vue
import Vue from 'vue';
import VueLazyLoad from 'vue-lazyload';
import App from './App.vue';
import router from './router';
import store from './store';
import Notifications from 'vue-notification';
import Helper from './lib/helper';
import VueCompositionAPI from '@vue/composition-api';

// fontawesome
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import * as icons from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// primevue
import PrimeVue from 'primevue/config';
import 'primeicons/primeicons.css';
import 'primevue/resources/primevue.min.css';
import ConfirmationService from 'primevue/confirmationservice';

// primeflex
import 'primeflex/primeflex.css';

Vue.use(PrimeVue, {
    ripple: true,
});

Vue.config.performance = true;

// old but gold
library.add(icons.faCoffee);
library.add(icons.faEdit);
library.add(icons.faClone);
library.add(icons.faEye);
library.add(icons.faTrash);
library.add(icons.faSignOutAlt);
library.add(icons.faExclamationTriangle);
library.add(icons.faCheck);
library.add(icons.faTimes);
library.add(icons.faFilePdf);
library.add(icons.faLock);
library.add(icons.faCalendarAlt);
library.add(icons.faArrowLeft);
library.add(icons.faArrowRight);
library.add(icons.faBell);
library.add(icons.faCog);
library.add(icons.faMapPin);
library.add(icons.faRulerCombined);
library.add(icons.faClock);
library.add(icons.faLink);
library.add(icons.faArrowRight);
library.add(icons.faClone);
library.add(icons.faAngleDoubleLeft);
library.add(icons.faAngleDoubleRight);
library.add(icons.faAngleRight);
library.add(icons.faExpandArrowsAlt);
library.add(icons.faCompressArrowsAlt);
library.add(icons.faEye);
library.add(icons.faEyeSlash);
library.add(icons.faPencilAlt);
library.add(icons.faCrosshairs);
library.add(icons.faCircle);
library.add(icons.faHeart);
library.add(icons.faImage);
library.add(icons.faTable);
library.add(icons.faChevronRight);
library.add(icons.faPlus);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;
Vue.use(Notifications);
Vue.use(VueLazyLoad);
Vue.use(VueCompositionAPI);
Vue.use(ConfirmationService);

// inject the global styles
import '@/styles/_style.css';
import '@/styles/ag-grid.scss';

const vm = new Vue({
    router,
    render: (h) => h(App),
});

vm.$store = store;
vm.$mount('#app');

export { vm };
